<template>
  <div>
    <Breadcrumb :breadcrumb="breadcurmb" />
    <div class="detail">
      <div class="header">{{ info.activityName }}</div>
      <div style="margin-top: 20px">
        <div class="information">
          <div class="title">
            <img src="../../assets/images/information-1.png" alt="" class="icon" /><span class="label"
              >主办单位： <span class="con">{{ info.organizer }}</span></span
            >
          </div>

          <div class="title">
            <img src="../../assets/images/information-2.png" alt="" class="icon" /><span class="label"
              >参与对象：<span class="con">{{ info.participant }}</span></span
            >
          </div>

          <div class="title">
            <img src="../../assets/images/information-3.png" alt="" class="icon" />
            <span class="label">
              活动时间： <span class="con">{{ info.activityTime }}</span>
            </span>
          </div>

          <div class="title" style="padding-bottom: 0px">
            <img src="../../assets/images/information-4.png" alt="" class="icon" /><span class="label"
              >活动地点： <span class="con">{{ info.activityPlace }}</span></span
            >
          </div>
        </div>
        <div class="content-title">活动内容</div>
        <div class="content" v-html="info.cont">
          <!-- {{ info.cont }} -->
        </div>
      </div>
      <template v-if="info.informationList && info.informationList.length">
        <div class="content-title">活动资讯</div>
        <div class="information-link">
          <a v-for="item in info.informationList" :key="item.id" :href="'https://nbrc.gov.cn/zzmh/#/news-detail/' + item.id" target="_blank">{{
            item.title
          }}</a>
        </div>
      </template>
      <div v-show="info.applyStatus" class="application">
        活动报名
        <div v-if="full" class="time" style="margin-top: 12px; color: red">该活动报名名额已满，您报名后将进入递补状态，感谢您对活动的支持，谢谢。</div>
        <div class="time">报名时间：{{ info.applyTime }}</div>
        <div style="margin: 20px">
          <!-- {{ codeKey }} -->
          <el-alert v-if="success" style="width: 300px" title="报名成功" type="success" :closable="false" show-icon />
          <form-create v-else v-model="dataForm" :rule="rule" :option="option" @submit="onSubmit" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from '@/components/Breadcrumb'
import formCreate from '@form-create/element-ui'
import { getUUID } from '@/utils/utils'
export default {
  name: 'ActivityDetail',
  components: { Breadcrumb },
  data() {
    return {
      imgUrl: process.env.NODE_ENV === 'production' ? '' : '/api',
      info: {},
      dataForm: {},
      success: false,
      codeKey: getUUID(),
      cryptoKey: '',
      rule: [],
      option: {},
      signNum: 0,
      breadcurmb: [
        {
          path: '/',
          name: '首页',
          meta: {
            title: '首页',
          },
        },
        {
          path: '/talent-Activities',
          name: '活动列表',
          meta: {
            title: '活动列表',
          },
        },
        {
          path: '/activity-Detail/:id',
          name: '活动详情',
          meta: {
            title: '活动详情',
          },
        },
      ],
    }
  },
  computed: {
    codeUrl() {
      return this.imgUrl + '/general/kaptcha/generate/' + this.codeKey
    },
    full() {
      return this.info.activityQuota <= this.signNum
    },
  },
  mounted() {
    this.getDetails().then(() => {
      this.getSignNum(this.info.id)
    })
    this.getCryptoKey()
  },
  methods: {
    getSignNum(id) {
      this.$http({ method: 'get', url: '/zzmh/api/activity/countApplyPerson?id=' + id }).then((res) => {
        this.signNum = res.data
      })
    },
    getCryptoKey() {
      this.$http({ method: 'get', url: '/general/access/getCryptoKey' })
        .then((res) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.cryptoKey = res.data
        })
        .catch(() => {})
    },
    getDetails() {
      console.log(this.$route.params.id)
      return this.$http({ method: 'get', url: '/zzmh/api/activity/info/' + this.$route.params.id }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.info = res.data
          let rawRule = formCreate.parseJson(res.data.formData)
          console.log(rawRule)
          if (rawRule) {
            this.rule = [
              ...rawRule,
              {
                type: 'input',
                field: 'codeVal',
                $required: '请输入验证码',
                style: { width: '150px' },
                title: '验证码',
                value: '',
                suffix: {
                  type: 'ElImage',
                  props: {
                    src: this.codeUrl,
                  },
                  on: {
                    click: () => {
                      console.log('code')
                      this.codeKey = getUUID()
                      this.rule[this.rule.length - 1].suffix.props.src = this.codeUrl
                    },
                  },
                  style: { 'height': '2.22222vw', 'vertical-align': 'middle', 'margin-left': '12px', 'cursor': 'pointer' },
                },
              },
            ]
          }
          this.option = formCreate.parseJson(res.data.ruleData)
        }
      })
    },
    onSubmit(data) {
      let codeVal = data.codeVal
      delete data.codeVal
      let params = {
        activityId: this.$route.params.id,
        applyData: JSON.stringify(data),
        codeKey: this.codeKey,
        cryptoKey: this.cryptoKey,
        codeVal: codeVal,
      }
      this.$http({ method: 'post', url: '/zzmh/api/activityApply/add', data: params }).then((res) => {
        if (res.code === 0) {
          this.$message.success('报名成功')
          this.success = true
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .el-form {
    /deep/ .el-input {
      width: 400px;
    }
  }
  .detail {
    background-color: #ffffff;
    margin-left: 8.3%;
    margin-right: 8.3%;
    min-height: 800px;
    padding: 10px 8.3333vw;
    .content-title {
      color: black;
      display: block;
      margin-top: 20px;
      font-size: 20px;
      font-weight: 600;
    }
    .header {
      margin-top: 20px;
      text-align: center;
      font-size: 24px;
      color: rgba(51, 51, 51, 0.85);
      text-align: center;
      line-height: 24px;
      font-weight: 600;
      height: 24px;
    }
    .content {
      width: 100%;
      font-size: 16px;
      color: #666;
      line-height: 36px;
      font-weight: 500;
      letter-spacing: 1px;
      margin-top: 10px;
    }
    .information-link {
      a {
        color: #2855f1;
        text-decoration: underline;
        display: block;
        margin-top: 8px;
        font-size: 18px;
      }
    }
    .information {
      color: black;
      vertical-align: top;
      height: 30%;
      width: 100%;
      background: #f6f7fb;
      font-size: 20px;
      font-weight: 600;
      padding: 20px;
      border-radius: 4px;
      .title {
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
        font-weight: 600;
        padding-bottom: 15px;
        display: flex;
        align-items: center;
        .icon {
          display: inline;
          padding-right: 5px;
          vertical-align: middle;
          height: 22px;
        }
        .label {
          display: inline;
          line-height: 22px;
        }
      }
      .con {
        font-size: 16px;
        color: rgba(102, 102, 102, 1);
        line-height: 22px;
        font-weight: 400;
        text-align: left;
      }
    }
    .application {
      color: black;
      display: block;
      margin-top: 70px;
      font-size: 20px;
      font-weight: 600;
      .time {
        margin-top: 15px;
        font-size: 16px;
        color: #666666;
        font-weight: 400;
      }
      .apply-content {
        display: block;
        width: 100%;
        margin-top: 20px;
        .input {
          font-weight: 400;
          font-size: 16px;
          text-align: right;
          margin-right: 30%;
          margin-top: 10px;
          ::-webkit-input-placeholder {
            padding-left: 5px;
            color: #777;
          }
        }
        .button {
          margin-top: 20px;
          margin-bottom: 20px;
          margin-right: 40%;
          text-align: right;
          .submit {
            background: #2855f1;
            border-radius: 4px;
            color: #fafafa;
            width: 176px;
            height: 40px;
            border: 0px;
          }
        }
      }
    }
    .clearfloat {
      clear: both;
      height: 0;
      font-size: 1px;
      line-height: 0px;
    }
  }
}
</style>
